import { createAction, createAsyncAction } from 'typesafe-actions';
export const contactUsAction = createAsyncAction('@contactUs/REQUEST', '@contactUs/SUCCESS', '@contactUs/FAILED')();
export const resetAction = createAction('@contactUs/RESET');
